<button
    *ngFor="let workflow of lstWorkFlow"
    style="margin-right: 5px"
    [hidden]="false"
    type="button"
    class="btn mr-2"
    [ngClass]="workflow.cssClass"
    [disabled]="false"
    (click)="_onClick(workflow, $event)"
>
    <i [ngClass]="workflow.cssIcon"></i>
    {{ workflow.buttonDisplayCde | localize }}
</button>
